import { Link } from '@tanstack/react-router';
import type { Project } from '@hangar/shared';
import { Icon } from '@/components/Icon';
import { StatusPill, Tag } from '@/components/badges';

/** Title with the slug and status, the description and the way back to the project. */
export function SettingsHeader({ project }: { project: Project }) {
  return (
    <header className="enter flex flex-col gap-2 border-b pb-6">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <h1 className="text-3xl font-semibold tracking-tight text-foreground max-sm:text-2xl">Project settings</h1>
        <Tag className="text-[13px] text-foreground">{project.slug}</Tag>
        <StatusPill status="succeeded" label="Active project" size="md" className="font-sans" />
      </div>
      <p className="max-w-[72ch] text-sm text-muted-foreground">{project.description || project.name}</p>
      <Link to="/projects/$slug" params={{ slug: project.slug }} className="inline-flex w-fit items-center gap-1 rounded-sm text-[13px] text-muted-foreground hover:text-foreground">
        Apps &amp; profiles of {project.name}
        <Icon name="arrow_forward" size={16} />
      </Link>
    </header>
  );
}
